<h3 class="dku-medium-title-sb mtop8 mbot8">{{ sectionTitle }}</h3>
<ng-content></ng-content>
